import React from 'react';

const Hero = ({ onPreOrderClick }) => {
  const scrollToShop = () => {
    document.getElementById('shop').scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section className="hero-banner">
      <img 
        src="https://customer-assets.emergentagent.com/job_gored-merch-drop/artifacts/2v69vx4n_rendered%20red%20GORED.png" 
        alt="GORED Banner"
        className="hero-banner-image"
      />
      <div className="hero-overlay-content">
        <div className="hero-cta-buttons">
          <button onClick={scrollToShop} className="btn-hero">
            OFFICIAL MERCH STORE
          </button>
          <button onClick={onPreOrderClick} className="btn-preorder-death">
            SHOP NOW
          </button>
        </div>
      </div>
    </section>
  );
};

export default Hero;
